module.exports = __webpack_public_path__ + "img/graphics-3.96536a94.svg";